import { render } from "./alternative_liveness_verification.html?vue&type=template&id=77a6f23c&external"
import script from "./alternative_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./alternative_liveness_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__